export const fullscreen = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 4H9.71429V6.28571H6.28571V9.71429H4V4ZM14.2857 4H20V9.71429H17.7143V6.28571H14.2857V4ZM17.7143 14.2857H20V20H14.2857V17.7143H17.7143V14.2857ZM9.71429 17.7143V20H4V14.2857H6.28571V17.7143H9.71429Z" fill="white" />
</svg>`;
